import React from 'react';

import { PhoneProviderContext } from '@app/providers/PhoneProvider/PhoneProvider';

interface FamilyDidNotReceiveCodeProps {
	onClick?: () => void;
}

const FamilyDidNotReceiveCode: React.FC<FamilyDidNotReceiveCodeProps> = ({ onClick }) => {
	const contextPhone = React.useContext(PhoneProviderContext);

	if (!contextPhone?.state) throw new Error('Error PhoneProvider context');

	return (
		<div className="center-center-content">
			<div className="online-booking__error-code-component">
				<div className="text">
					<p>
						We’re sorry! Your verification code could not be confirmed. Please call
						{' '}
						<span className="inline-block">
							<a href={contextPhone.state.phoneNumberHref} className="inline-link">
								{contextPhone.state.phoneNumberDisplay}
							</a>
						</span>
						{' '}
						to help finalize your booking.
					</p>
					<p>Thank you for your patience!</p>
				</div>
			</div>
		</div>
	);
};

export default FamilyDidNotReceiveCode;
